module.exports = __webpack_public_path__ + "static/media/Umayon.46c4d46b.png";